import React, { useState, useContext, useEffect } from 'react'
import { Box, TextInput, Button, Grommet, Image, Text } from 'grommet'
import { AuthContext } from './Routes'
import { Auth } from 'aws-amplify'
import { Redirect } from 'react-router-dom'
import WaveLoading from '@bit/akameco.styled-spinkit.wave-loading'
import theme from '../theme'

function Login({ isAuthenticated, sso }) {
  const [singleSignOn, setSingleSignOn] = useState(sso)
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [newPassword, setNewPassword] = useState('')
  const [errorMessage, setErrorMessage] = useState('')
  const [challenge, setChallenge] = useState({})
  const [loading, setLoading] = useState(false)
  const authContext = useContext(AuthContext)

  const signIn = async (email, password, newPassword) => {
    const { setLoggedIn } = authContext

    if (email && password) {
      try {
        const user = await Auth.signIn(email, password)
        if (user.challengeName === 'NEW_PASSWORD_REQUIRED') {
          setErrorMessage('Enter your new password')
          setChallenge({
            challengeName: user.challengeName,
          })
          if (newPassword) {
            await Auth.completeNewPassword(user, newPassword)
            setLoggedIn(true)
          }
        } else {
          setLoggedIn(true)
        }
      } catch (e) {
        setErrorMessage(e.message)
      }
    }
  }
  useEffect(() => {
    const iss = decodeURIComponent(window.location.search.substring(1).split('=')[1]) || ''
    if (iss === 'https://illumio.okta.com') {
      setLoading(true)
      setSingleSignOn(true)
      setTimeout(() => {
        authContext.auth.getSession()
      }, 1000)
    }
  }, [authContext.auth])

  return (
    <Grommet theme={theme}>
      <Box pad="medium" justify="center" align="center" height="100vh" font="inherit" background="#0172B9">
        <Box
          height="30vh"
          width="70vh"
          direction="row"
          onKeyDown={e => {
            if (e.key === 'Enter') {
              signIn(email, password, newPassword)
            }
          }}
          background="#E3F2FD"
        >
          <Box
            width="40%"
            background="white"
            justify="center"
            align="center"
            border={{ color: 'brand', side: 'right' }}
          >
            <Box>
              <Image
                width="150px"
                fit="cover"
                src="https://www.illumio.com/hubfs/illumio_logo_color_svg-164x40.svg"
              ></Image>
            </Box>
          </Box>
          <Box width="60%" justify="center" align="center">
            <Box width="large" justify="center" align="center">
              {singleSignOn ? null : (
                <>
                  <Box margin="small" width="60%" background="white">
                    <TextInput type="email" size="small" placeholder="Email" onInput={e => setEmail(e.target.value)} />
                  </Box>
                  <Box width="60%" background="white">
                    <TextInput
                      type="password"
                      size="small"
                      placeholder={challenge.challengeName ? 'Old password' : 'Password'}
                      value={password}
                      onInput={e => setPassword(e.target.value)}
                    />
                  </Box>
                </>
              )}
              {challenge.challengeName && (
                <Box margin="small" width="60%" background="white">
                  <TextInput
                    type="password"
                    size="small"
                    placeholder="Enter your new password"
                    value={newPassword}
                    onInput={e => setNewPassword(e.target.value)}
                  />
                </Box>
              )}
              <Box height="10px">
                <Text color="red">{errorMessage}</Text>
              </Box>
              <Box margin="small" width="150px">
                {loading ? (
                  <WaveLoading color={theme.global.colors.brand} size={60} />
                ) : singleSignOn ? (
                  <Button
                    id="login"
                    primary
                    label="Login with Okta"
                    onClick={() => authContext.auth.getSession()}
                    alignSelf="center"
                  />
                ) : (
                  <Button
                    primary
                    label={challenge.challengeName === 'NEW_PASSWORD_REQUIRED' ? 'Submit' : 'Login'}
                    onClick={() => signIn(email, password, newPassword)}
                  />
                )}
              </Box>
              {authContext.loggedIn && <Redirect to="/" />}
            </Box>
          </Box>
        </Box>
      </Box>
    </Grommet>
  )
}

export default Login
